import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
  Box,
  Tooltip,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { cross_icon_with_back } from "../../assets";

const GeneralMUIDialog = ({
  open,
  setOpen,
  title,
  content,
  onClick = null, // optional form submit handler
  onSubmit = null, // optional form submit handler
  actionText = "Submit", // primary button text
  actionSubmittingText = "Submitting...", // primary button text
  cancelText = "Cancel", // cancel button text
  loading = false, // optional loading state
  maxWidth = "sm",
  fullWidth = true,
  disableClose = false,
  disableAction = false,
  showCloseIcon = true,
  showCloseButton = true,
  showActionButton = true,
  disableReason = "",
}) => {
  const isForm = typeof onSubmit === "function";

  const handleSubmit = (e) => {
    if (isForm && !disableAction) {
      e.preventDefault();
      onSubmit(e);
    }
  };

  const onClose = () => {
    setOpen(false);
  };

  return (
    <Dialog
      className="dialouge-css"
      open={open}
      onClose={disableClose ? undefined : onClose}
      maxWidth={maxWidth}
      fullWidth={fullWidth}
      PaperProps={{
        component: isForm ? "form" : "div",
        onSubmit: isForm ? handleSubmit : undefined,
      }}
    >
      {/* Header */}
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
        className="py-4 border-bottom"
      >
        {title}
        {showCloseIcon && (
          // <IconButton
          //   aria-label="close"
          //   onClick={onClose}
          //   sx={{ color: (theme) => theme.palette.grey[500] }}
          // >
          //   <CloseIcon />
          // </IconButton>
          <img
            src={cross_icon_with_back}
            height={40}
            width={40}
            onClick={onClose}
            className="cursor-pointer"
          ></img>
        )}
      </DialogTitle>

      {/* Content */}
      <DialogContent className="px-4 pt-4 pb-3">
        <Box>{content}</Box>
      </DialogContent>

      {/* Actions (auto-generated) */}
      {(showActionButton || showCloseButton) && (
        <DialogActions className="px-4 py-3">
          {showCloseButton && (
            <button
              onClick={onClose}
              disabled={loading}
              className="small-button-outline"
            >
              {cancelText}
            </button>
          )}
          {showActionButton && (
            <Tooltip title={disableAction ? disableReason : ""} arrow>
              <span>
                <button
                  type={isForm ? "submit" : "button"}
                  disabled={loading || disableAction}
                  className="small-button-cotain-view-all"
                  onClick={!isForm ? onClick : undefined}
                >
                  {loading ? actionSubmittingText : actionText}
                </button>
              </span>
            </Tooltip>
          )}
        </DialogActions>
      )}
    </Dialog>
  );
};

export default GeneralMUIDialog;
